module.exports = __webpack_public_path__ + "static/media/pie.9336ab60.png";